<template>
    <b-card class="card-foldable" no-body>
        <b-link :class="collapseLinkClasses" :disabled="disabled" :to="routeConfig">
            <span class="text-uppercase font-weight-bold foldable-headline">{{ title }}</span>
        </b-link>
        <b-collapse :id="collapseId" accordion="my-accordion" role="tabpanel" :visible="isSectionActive">
            <b-card>
                <slot v-if="isSectionActive"/>

                <div v-if="linkToSection">
                    <b-button class="m-3" :to="sectionLinkParams" variant="primary">
                        Weiter
                    </b-button>
                </div>
            </b-card>
        </b-collapse>
    </b-card>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                required: false,
            },
            collapseId: {
                type: String,
                required: true,
            },
            linkClasses: {
                type: Array,
                default() {
                    return [];
                },
            },
            linkToSection: {
                type: String,
                required: false,
                default: '',
            },
            routeName: {
                type: String,
                default: 'record-detail',
            },
            routeParams: {
                type: Object,
                default() {
                    return null;
                },
            },
            title: {
                type: String,
                required: true,
            },
        },
        computed: {
            collapseLinkClasses() {
                let classes = [
                    'foldable-header',
                    'text-left',
                ];

                classes = classes.concat(this.linkClasses);

                if (!this.isSectionActive) {
                    classes.push('collapsed')
                }

                return classes;
            },
            isSectionActive() {
                return this.$route.params.section === this.collapseId;
            },
            routeConfig() {
                const routeParams = this.routeParams || {recordId: this.$route.params.recordId};

                if (this.isSectionActive) {
                    return {
                        name: this.routeName,
                        params: routeParams,
                    };
                }

                routeParams.section = this.collapseId;
                return {
                    name: this.routeName + '-section',
                    params: routeParams,
                };
            },
            sectionLinkParams() {
                return {name: this.routeName + '-section', params: {section: this.linkToSection}};
            },
        },
    }
</script>
